/** Characters kept at the start of a shortened session id (mockup: `sess_8f3a…`). */
const SESSION_ID_HEAD_LENGTH = 9;
/** Characters kept at the end of a shortened session id (mockup: `…6ef2`). */
const SESSION_ID_TAIL_LENGTH = 4;
const SESSION_ID_ELLIPSIS = '…';

/**
 * Shorten a session id for the Alert Variations table so the column stays
 * compact. The full id stays in the transcript tooltip and on copy; this
 * is display-only.
 *
 * @param sessionId - The full session id.
 * @returns The original id when it already fits; otherwise head + ellipsis + tail.
 */
export function shortenSessionId(sessionId: string): string {
  if (sessionId.length <= SESSION_ID_HEAD_LENGTH + SESSION_ID_TAIL_LENGTH) {
    return sessionId;
  }
  return `${sessionId.slice(0, SESSION_ID_HEAD_LENGTH)}${SESSION_ID_ELLIPSIS}${sessionId.slice(-SESSION_ID_TAIL_LENGTH)}`;
}
